import script from "./HospitalLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./HospitalLogin.vue?vue&type=script&setup=true&lang=ts"

import "./HospitalLogin.vue?vue&type=style&index=0&id=c5ee11fe&lang=css"

const __exports__ = script;

export default __exports__